import { Store } from 'vuex'
import Vue from 'vue'
import forEach from 'lodash/forEach'
import { emitter } from '@kwixeo/interface-vue'
import { AxiosResponse } from 'axios'
import moment from 'moment'

const moduleActions = (store: Store<KwixeoInterface.AnyValue>, module: KwixeoSubscriptions.Module) => {
  store.dispatch('subscriptions/setModule', module)
  store.dispatch('globalDatas/clearUserRoles')
  store.dispatch('globalDatas/clearUserPermissions')
  emitter.emit('teamModuleUpdated', module)
}

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.TeamSubscriptionUpdated',
    callback: async (subscription: KwixeoSubscriptions.TeamSubscriptionBroadcast): Promise<void> => {
      if (!moment(store.getters['user/team'].subscription.updated_at).isBefore(subscription.updated_at)) {
        return
      }
      await Vue.prototype.$kwSubscriptions.axios.get('/team/subscription')
        .then((response: AxiosResponse) => {
          const team = JSON.parse(JSON.stringify(store.getters['user/team']))
          team.subscription = response.data.subscription
          store.dispatch('user/setTeam', team)
        })
    }
  },
  {
    name: '.TeamModuleCreated',
    callback: (module: KwixeoSubscriptions.Module): void => moduleActions(store, module)
  },
  {
    name: '.TeamModuleUpdated',
    callback: (module: KwixeoSubscriptions.Module): void => moduleActions(store, module)
  },
  {
    name: '.AppCommandValidated',
    callback: (modules: KwixeoSubscriptions.Modules): void => {
      forEach(modules, module => {
        store.dispatch('subscriptions/setTeamModule', module)
        emitter.emit('teamModuleUpdated', module)
      })
    }
  }
])

